import React from 'react';
import { Users, UserCheck, PauseCircle } from 'lucide-react';

const SystemUserStats = ({ stats, statusFilter, onStatusChange }) => {
    if (!stats) return null;

    const inactive = stats.totalUsers - stats.activeUsers;
    const inactiveHint = [
        stats.suspendedUsers && `${stats.suspendedUsers} suspended`,
        stats.lockedUsers && `${stats.lockedUsers} locked`,
    ].filter(Boolean).join(' · ');

    const tiles = [
        { title: 'Total users', value: stats.totalUsers, icon: Users, filter: 'ALL', tone: 'bg-blue-100 text-blue-600' },
        { title: 'Active', value: stats.activeUsers, icon: UserCheck, filter: 'ACTIVE', tone: 'bg-green-100 text-green-600' },
        { title: 'Inactive', value: inactive, icon: PauseCircle, filter: 'INACTIVE', hint: inactiveHint, tone: inactive ? 'bg-amber-100 text-amber-600' : 'bg-gray-100 text-gray-500' },
    ];

    return (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            {tiles.map((t) => (
                <button
                    key={t.title}
                    type="button"
                    onClick={() => onStatusChange(t.filter)}
                    className={`flex items-center justify-between rounded-lg border bg-white p-4 text-left transition hover:border-blue-300 ${statusFilter === t.filter ? 'border-blue-400 ring-1 ring-blue-200' : 'border-gray-200'}`}
                >
                    <div>
                        <p className="text-xs font-medium uppercase tracking-wider text-gray-500">{t.title}</p>
                        <p className="text-2xl font-bold text-gray-900">{t.value.toLocaleString()}</p>
                        {t.hint && <p className="text-xs text-gray-500">{t.hint}</p>}
                    </div>
                    <span className={`rounded-lg p-2.5 ${t.tone}`}>
                        <t.icon className="w-5 h-5" />
                    </span>
                </button>
            ))}
        </div>
    );
};

export default SystemUserStats;
